import { MediaControl } from "./MediaControl";
import { ConfigSection, ResourceDemandIndicator, SegmentedSetting } from "./MediaSettings";
import { SpectatorsControl } from "./SpectatorsControl";
import { focusRing } from "../ui/control-styles";
import { tooltipArrow, tooltipSurface } from "../ui/tooltip";
import { useTranslation } from "react-i18next";

const FRAME_RATE_OPTIONS = [
  { value: "5", label: "5 FPS", nativeLabel: "5 fps" },
  { value: "15", label: "15 FPS", nativeLabel: "15 fps" },
  { value: "30", label: "30 FPS", nativeLabel: "30 fps" },
  { value: "60", label: "60 FPS", nativeLabel: "60 fps" },
];
export function ScreenControl() {
  const { t } = useTranslation();
  const resolutionOptions = [
    { value: "720", label: "720p", nativeLabel: "1280 × 720" },
    { value: "1080", label: "1080p", nativeLabel: "1920 × 1080" },
    { value: "1440", label: "1440p", nativeLabel: "2560 × 1440" },
    { value: "native", label: t("common.native"), nativeLabel: t("settings.nativeAutomatic") },
  ];
  const contentOptions = [
    { value: "", label: t("settings.auto"), nativeLabel: t("common.automatic") },
    { value: "detail", label: t("settings.detail"), nativeLabel: t("settings.detail") },
    { value: "text", label: t("settings.text"), nativeLabel: t("settings.text") },
    { value: "motion", label: t("settings.motion"), nativeLabel: t("settings.motion") },
  ];
  return (
    <MediaControl
      source="screen"
      title={t("screen.settingsTitle")}
      description={t("screen.settingsDescription")}
      extra={
        <SpectatorsControl
          kind="host"
          className="host-control absolute bottom-[calc(100%+var(--spacing))] left-1/2 z-3 grid -translate-x-1/2 place-items-center"
          buttonClassName={`host-control-button relative inline-flex h-6 min-w-10.5 cursor-pointer items-center justify-center px-2 py-0 ${tooltipSurface} hover:bg-secondary aria-expanded:bg-secondary ${focusRing}`}
          arrowClassName={`${tooltipArrow} absolute -bottom-1 left-1/2 -translate-x-1/2 bg-inherit`}
        />
      }
    >
      <ConfigSection title={t("screen.pictureTitle")} description={t("screen.pictureDescription")}>
        <SegmentedSetting
          title={t("settings.resolution")}
          label={t("settings.screenResolution")}
          target="screenResolution"
          options={resolutionOptions}
        />
        <SegmentedSetting
          title={t("settings.frameRate")}
          label={t("settings.screenFrameRate")}
          target="screenFps"
          options={FRAME_RATE_OPTIONS}
        />
        <SegmentedSetting
          title={t("settings.optimizeFor")}
          label={t("settings.contentOptimization")}
          target="contentHint"
          options={contentOptions}
        />
        <ResourceDemandIndicator />
      </ConfigSection>
    </MediaControl>
  );
}
